import { WorkspaceMemberRole } from './WorkspaceMemberRole';
import type { UserId, WorkspaceMemberRoleJSON, WorkspaceMemberRolesJSON } from 'balus-common';

type WorkspaceMemberRoleRecord = Record<UserId, WorkspaceMemberRole>;

export class WorkspaceMemberRoles {
  private readonly memberRoles: Readonly<WorkspaceMemberRoleRecord>;
  constructor(memberRoles: WorkspaceMemberRoleRecord) {
    this.memberRoles = { ...memberRoles };
  }

  dump(): WorkspaceMemberRolesJSON {
    return { ...this.memberRoles };
  }

  static load(dump: WorkspaceMemberRolesJSON | null): WorkspaceMemberRoles {
    return this.fromEntities(Object.entries(dump || {}));
  }

  static fromEntities(entries: [UserId, WorkspaceMemberRoleJSON][]): WorkspaceMemberRoles {
    const roles: WorkspaceMemberRoleRecord = {};
    entries.forEach(([userId, value]) => {
      roles[userId] = WorkspaceMemberRole.load(value);
    });
    return new WorkspaceMemberRoles(roles);
  }

  getRoleOf(userId: UserId): WorkspaceMemberRole | null {
    return this.memberRoles[userId] || null;
  }

  get length(): number {
    return Object.keys(this.memberRoles).length;
  }

  entries(): [UserId, WorkspaceMemberRole][] {
    return Object.entries(this.memberRoles).map(([userId, role]) => [userId, role]);
  }

  userIds(): UserId[] {
    return Object.keys(this.memberRoles);
  }

  userIdsByRole(role: WorkspaceMemberRole): UserId[] {
    return this.entries()
      .filter(([, value]) => value === role)
      .map(([userId]) => userId);
  }

  hasMembersOf(role: WorkspaceMemberRole): boolean {
    return this.userIdsByRole(role).length > 0;
  }
}
